<template>
	<div class="my-3 jur-view">
		<div class="jur-toolbar my-3">
			<div class="actions d-flex">
					<button
						v-if="userHasAllNeededJuniperPermissions(['create_roles'])"
						@click="openCreateRoleModal()"
						class="j-action-btn jur-action-btn--primary"
					>
						<font-awesome-icon :icon="['fas', 'user-tag']" class="me-1" /> Add New Role
					</button>
			</div>
		</div>
		<div class="jur-panel">
			<div class="d-flex align-items-center flex-wrap gap-2">
				<span class="text-nowrap me-2 fw-bold">Select Role:</span>
				<select class="form-select jur-role-select" aria-label="Roles" v-model="selectedRoleId">
					<option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
				</select>
			</div>
			<div id="tw-permissions-table-wrapper" v-if="selectedRole" class="mt-4 flex-grow-1">
				<table id="tw-permissions-table">
					<tbody>
						<tr>
							<td class="jur-table-head-left" style="width: 30%;"><b>Group</b> (Total/Granted)</td>
							<td class="p-2">
								<div class="row g-2 align-items-center">
									<div class="search col-lg-4">
										<div class="form-group">
											<input type="text" v-model="search" class="form-control" placeholder="Search permissions..." />
										</div>
									</div>
									<div class="col-lg-8 text-end text-nowrap">
										<button
											v-if="userHasAllNeededJuniperPermissions(['update_roles'])"
											@click="openCreateRoleModal(true)"
											class="j-action-btn me-2"
										>
											<font-awesome-icon :icon="['far', 'edit']" class="me-1" /> Rename Role
										</button>
										<button
											v-if="userHasAllNeededJuniperPermissions(['sync_role_permissions'])"
											@click="updateRolePermissions"
											class="j-action-btn jur-action-btn--primary me-2"
										>
											<font-awesome-icon :icon="['far', 'save']" class="me-1" /> Update Permissions
										</button>
										<button
											v-if="userHasAllNeededJuniperPermissions(['delete_roles'])"
											@click="deleteRole"
											class="j-action-btn jur-action-btn--danger"
										>
											<font-awesome-icon :icon="['fas', 'trash-alt']" class="me-1" /> Delete Role
										</button>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td class="pt-3 text-nowrap jur-groups-col">
								<ul>
									<li class="cursor-pointer" :class="{'selected': !selectedGroup}" @click="selectedGroup = null">All({{ permissionsTotal }}/{{ selectedRole.permissions.length }})</li>
									<li v-for="group in permissionGroups" :key="group.id" class="cursor-pointer permission-group" :class="{'selected': selectedGroup == group.id}" @click="selectedGroup = group.id">
										- {{ group.name }} ({{ group.permissions.length }}/{{ selectedRole.permissions.filter(permission => {return permission.group_id == group.id} ).length }})
									</li>
								</ul>
							</td>
							<td class="p-3 jur-perms-col">
								<div id="tw-role-permissions-wrapper">
									<div v-for="permission in permissions" v-show="((search === '' || permission.name.includes(search))) && (!selectedGroup || (permission.group_id == selectedGroup))" :key="'permission-' + permission.id"  class="form-check">
										<input class="form-check-input" type="checkbox" :value="permission.id" :id="'permission-' + permission.id" v-model="selectedRolePermissions" :disabled="!userHasAllNeededJuniperPermissions(['update_roles'])">
										<label class="form-check-label" :for="'permission-' + permission.id">
											{{ permission.name }}
										</label>
										<span v-if="permission.description" class="text-info cursor-help ms-1" data-bs-custom-class="custom-tooltip" data-bs-html="true" data-bs-trigger="focus" tabindex="0" data-bs-toggle="tooltip" data-bs-placement="right" :title="permission.description"><font-awesome-icon :icon="['fas', 'info-circle']" /></span>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<CreateRoleModal ref="CreateRoleModal" @roleSaved="handleRoleSaved" :update="updateRoleAction" :roleForChildComponent="roleForUpdate" @createRoleModalClosed="handleCreateRoleModalClosed"/>
	</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import juniperApi from '@/api/juniperApi';
import CreateRoleModal from '@/components/juniper/modals/CreateRoleModal.vue';
import juniperUserMixin from "@/mixins/juniperUserMixin";
import { Tooltip } from "bootstrap";
export default {
	name: 'UserRoles',
	data() {
		return {
			loading: false,
			roles: [],
            permissionGroups: [],
            permissions: [],
            selectedGroup: null,
            selectedRole: null,
            selectedRoleId: 2,
            selectedRolePermissions: [],
			page: 1,
			totalRoles: 0,
			perPage: 10,
			search: '',
			pagination: null,
            permissionsTotal: 0,
            updateRoleAction: false,
            roleForUpdate: {name: ''},
		}
	},
	components: {
		CreateRoleModal
	},
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
	},
    updated() {
		let tooltopElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');

		tooltopElements.forEach(element => {

			let tooltip = Tooltip.getInstance(element);

			if (tooltip) {
				tooltip.dispose();
			}

			if (!Tooltip.getInstance(element)) {
				new Tooltip(element)
			}
		});
	},
	created() {
		this.getRoles();
	},
	watch: {
        selectedRoleId: function () {
            this.setSelectedRole();
        },
    },
	methods: {
		getRoles(savedId = null) {
			this.loading = true
			juniperApi
				.get(`/roles`)
				.then(({ data }) => {
                    
					this.roles = data;

                    if (savedId) {
                        this.selectedRoleId = savedId;
                    } else {
                        this.setSelectedRole();
                    }


                    this.getPermissionGroups();
                    
					this.loading = false;
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},
        setSelectedRole() {
            this.selectedRole = this.roles.find((role) => {return role.id == this.selectedRoleId});
            this.selectedRolePermissions = this.selectedRole.permissions.map(permission => permission.id);
        },
        getPermissionGroups() {
			this.loading = true
			juniperApi
				.get(`/permission-groups`)
				.then(({ data }) => {
                    
					this.permissionGroups = data;

                    this.getPermissionsAndCount();
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},
        getPermissionsAndCount() {
            this.permissions = [];
            this.permissionsTotal = 0;
            this.permissionGroups.forEach(group => {
                group.permissions.forEach(permission => {
                    this.permissions.push(permission);
                })
                this.permissionsTotal += group.permissions.length;
            });
        },
        countPermissions() {
            this.permissionGroups.forEach(group => {
                this.permissionsTotal += group.permissions.length;
            });
        },
        openCreateRoleModal(update = false) {
            if (update) {
                this.updateRoleAction = true;
                this.roleForUpdate = this.selectedRole;
            }
            this.$refs.CreateRoleModal.showModal(true);
        },
        handleRoleSaved(id) {
            this.getRoles(id);
        },
        handleCreateRoleModalClosed() {
			this.updateRoleAction = false;
            this.roleForUpdate = {name: ''};
		},
        updateRolePermissions () {
            this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                text: `Are you sure you want to update role permissions?`,
                confirmButtonText: `Yes, do it!`,
                showLoaderOnConfirm: true,
				toast: false,
				position: 'center',
				showConfirmButton: true,
				timer: undefined,
				timerProgressBar: false,
				confirmButtonColor: "#0FCB4F",
				cancelButtonColor: "#EC2641",
                preConfirm: async () => {
                    try {
                        let res = await juniperApi.put(`/roles/${this.selectedRoleId}/sync-permissions`, {permissions: this.selectedRolePermissions});

                        return res;
                    } catch (error) {
                        this.$swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then(async (result) => {
                if (result.isConfirmed) {
					if (result.value && result.value.data == 'success') {
                        
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Role permissions updated successfully!',
                            timer: 4000,
                        });
						this.loading = true;
						this.getRoles();
					} else {
						this.$swal("Request failed!", `There was a problem, role permissions wasn't updated.`, "error");
					}
                }
            });
        },
        deleteRole () {
            this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                text: `Are you sure you want to delete selected role?`,
                confirmButtonText: `Yes, delete it!`,
                showLoaderOnConfirm: true,
				toast: false,
				position: 'center',
				showConfirmButton: true,
				timer: undefined,
				timerProgressBar: false,
				confirmButtonColor: "#0FCB4F",
				cancelButtonColor: "#EC2641",
                preConfirm: async () => {
                    try {
                        let res = await juniperApi.delete(`/roles/${this.selectedRoleId}`);

                        return res;
                    } catch (error) {
                        this.$swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then(async (result) => {
                if (result.isConfirmed) {
					if (result.value && result.value.data == 'success') {
                        
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Role deleted successfully!',
                            timer: 4000,
                        });

						this.loading = true;
                        this.selectedRoleId = 2;
						this.getRoles();
					} else {
						this.$swal("Request failed!", `There was a problem, role wasn't updated.`, "error");
					}
                }
            });
        }
	},
    mixins: [juniperUserMixin]
}
</script>
<style scoped>
#tw-permissions-table-wrapper {
	overflow-x: auto;
}

.jur-toolbar {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.jur-panel {
	background: #ffffff;
	border: 1px solid #e2e8f0;
	border-radius: 14px;
	padding: 12px;
	min-height: calc(100vh * .72);
}

.jur-role-select {
	max-width: 320px;
}

#tw-permissions-table {
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
}

#tw-permissions-table tbody tr:first-child td {
	background: #f8fafc;
	border-bottom: 1px solid #e2e8f0;
}

#tw-permissions-table tr td:first-child {
	border-right: 1px solid #e2e8f0;
}

.jur-table-head-left {
	font-size: 12px;
	color: #64748b;
	font-weight: 700;
	padding: 10px 12px;
}

.jur-groups-col {
	background: #fbfcfe;
	vertical-align: top;
}

#tw-permissions-table tr td ul {
	list-style: none;
	padding: 0;
	margin: 0;
}

#tw-permissions-table tbody tr td ul li {
	padding: 6px 10px;
	border-radius: 8px;
	font-size: 13px;
	color: #334155;
}

#tw-permissions-table > tbody tr td ul li.permission-group {
	padding-left: 20px;
}

#tw-permissions-table tr td li.selected {
	background-color: #e2e8f0;
	border-radius: 8px;
	font-weight: 600;
}

#tw-permissions-table tr td li:hover {
	background: #eef2f7;
}

#tw-permissions-table tbody tr:nth-child(2) {
	vertical-align: baseline;
	height: calc(100vh * .55);
}

.jur-perms-col {
	background: #ffffff;
}

#tw-role-permissions-wrapper {
	height: calc(100vh * .5);
	overflow-y: auto;
	padding-right: 4px;
}

#tw-role-permissions-wrapper .form-check {
	padding: 6px 8px 6px 28px;
	border-bottom: 1px solid #f1f5f9;
}

#tw-role-permissions-wrapper .form-check:last-child {
	border-bottom: 0;
}

.jur-action-btn--primary {
	background: #2563eb;
	border-color: #2563eb;
	color: #fff;
}

.jur-action-btn--primary:hover {
	background: #1d4ed8;
	border-color: #1d4ed8;
	color: #fff;
}

.jur-action-btn--danger {
	background: #dc2626;
	border-color: #dc2626;
	color: #fff;
}

.jur-action-btn--danger:hover {
	background: #b91c1c;
	border-color: #b91c1c;
	color: #fff;
}
</style>
